import Minze, { MinzeElement, Reactive, EventListeners, Attrs } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'
import { inlineStyle } from '../../modules/utils'
import { Locale } from '../../modules/locale'
import { Font } from '../../constants'

Locale.getInstance().registerKeySet('fr', 'geoButton', {
  empty: 'Sélectionner',
})

Locale.getInstance().registerKeySet('en', 'geoButton', {
  empty: 'Select',
})

export interface LvcGeoButton {}

export class LvcGeoButton extends MinzeElement {
  attrs: Attrs = ['theme']
  reactive: Reactive = ['location']
  static observedAttributes = ['theme']

  onReady = () => {
    let mainModule = MainModule.getInstance()
    mainModule.getEE().on('geo:location', location => {
      this.handleLocationChange(location)
    })
    const geo = mainModule.getGeo()
    this.handleLocationChange(geo?.currentLocation)
  }

  handleLocationChange = (location: any) => {
    if (!location) {
      this.location = Locale.getKey('geoButton.empty')
      return
    }

    this.location = `${location?.name} (${location?.county})`
  }

  onClick = async () => {
    const mainModule = MainModule.getInstance()
    mainModule.injectIntoDOM('lvc-geo-drawer')
    try {
      await mainModule.analyticsTrack('accueil_grid_onglet', {
        link_text: 'Lieu',
      })
    } catch (error) {
      console.error('Error tracking analytics:', error)
    }
  }

  html = () => {
    if (!this.location) return ``

    return `
      <lvc-location-icon></lvc-location-icon>
      <div class="text">${this.location}</div>
      <lvc-chevron-down-icon></lvc-chevron-down-icon>
    `
  }

  css = () => `
    :host {
      font-size: 0.875rem;
      width: ${this.theme === 'alternative' ? '200px' : '220px'};
      height: ${this.theme === 'alternative' ? '40px' : '50px'};
      color: #1E007D;
      display: flex;
      align-items: center;
      gap: ${this.theme === 'alternative' ? '10px' : '10px'};
      padding: ${this.theme === 'alternative' ? '0px 12px' : '0px 12px'};
      cursor: pointer;
      background: ${this.theme === 'alternative' ? '#BFF0FF' : '#fff'};
      border-radius: 999px;
    }
    .text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    lvc-location-icon {
      margin-top: 5px;
    }
    lvc-chevron-down-icon {
      margin-left: auto;
    }
    @media only screen and (max-width: 991px) {
      :host {
        width: 100%;
        height: 52px;
      }
      
    }
   `

  eventListeners: EventListeners = [[this, 'click', this.onClick]]
}
